import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import Handlebars from 'handlebars';
import GenericView from '../../prototypes/generic.view.ts';
import Template from 'text-loader!../templates/forgotPassword.template.hbs';
import i18n from "l10n";
import "compat";

export default GenericView.extend({
    el: "#main",
    tagName: 'div',
    template: Handlebars.compile(Template),
    initialize: function () {
        this.render();
        this.fields =
            {
              email: [this.isEmpty, this.isEmail]
            };
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        var self = this;

        this.$el.html(this.template());
    },
    events:{
        "submit #form": "forgot",
        "keyup #email": "forgotWithEnter"
    },
    forgot: function()
    {
        var self = this;
        var email = encodeURIComponent($("#email").val());

        var fields = $.extend({}, this.fields);

        var has_error_email = this.validateFields(fields);

        if(has_error_email) {
            $.notify(i18n.t("account.sth_wrong"), {className: "error"});
            return;
        }
        $.ajaxDefaultQ({
            url: window.ip+'/rest/auth/users/forgotPassword?email=' + email,
            type: 'GET'
        }).done(function(response, status, xhr){
            if (response && response.error != null) {
                if (response.error.message == "EMAIL_SEND_FAIL") {
                    $.notify(
                        i18n.t('error.email_send_fail'),
                        { position:"top center", className: "error" }
                    );
                    return ;
                }
            }

            if(status == "success")
            {
                $.notify(i18n.t("account.forgotPasswordEmail"), { position:"top center", className: "success"});
                setTimeout(() => {
                    window.open('/login.html','_self');
                }, 5000);
            }
        })
        .fail(function(response) {
           $.notify(i18n.t("account.sth_wrong"), {className: "error"});
        })


        return false;
    },
    forgotWithEnter: function(event)
    {
        event.preventDefault();
        if(this.isEmail("#email")) {
            if (event.keyCode == 13) {
                if($("#email").val() != null) {
                    this.forgot();
                }
            }
        }
    }
});

